import { HttpParams } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { DateTableColumn, StatusTableColumn, TableColumn } from '../../../components/kiene-table/table-column';
import { TableDescriptor } from '../../../components/kiene-table/table-descriptor';
import { TicketFarben } from '../../../../../projects/kiene-core/src/lib/classes/ticket';

@Component({
    selector: 'kiene-ticket-statushistorie',
    templateUrl: './ticket-statushistorie.component.html',
    styleUrls: ['./ticket-statushistorie.component.scss'],
})
export class TicketStatushistorieComponent implements OnInit {
    tableDescriptor = new TableDescriptor();
    ticket_id!: string;

    constructor(
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private route: ActivatedRoute,
    ) {}

    ngOnInit(): void {
        this.ticket_id = this.route.snapshot.paramMap.get('id');
        this.initOpenTable();
    }

    initOpenTable() {
        this.tableDescriptor.headline = 'Statuswechsel';
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'ticket_statushistorie/';

        let params = new HttpParams().set('geloescht', '0');
        params = params.append('ticket_id', this.ticket_id.toString());

        this.tableDescriptor.params = params;
        this.tableDescriptor.initialSortDirection = 'desc';
        this.tableDescriptor.initialSortColumn = 'prioritaet';
        this.tableDescriptor.nameOfIdField = 'ticket_id';
        this.tableDescriptor.uniqueIdentifier = 'Statushistorie';
        this.tableDescriptor.showSearchBar = false;
        this.tableDescriptor.createAllowed = false;
        this.tableDescriptor.showDetails = false;

        this.tableDescriptor.permissionView = 10031;
        this.tableDescriptor.permissionCreate = 10032;

        this.tableDescriptor.columns = this.getOpenColumns();
        // this.openTableDescriptor.options = this.getOpenOptions();
    }

    getOpenColumns() {
        const columns = [];
        columns.push(new TableColumn('tsh_id', 'ID', 'number', true));
        const valueColorMap = new Map<number, string>();
        valueColorMap.set(230, TicketFarben.getColor(230));
        valueColorMap.set(229, TicketFarben.getColor(229));
        valueColorMap.set(228, TicketFarben.getColor(228));
        valueColorMap.set(227, TicketFarben.getColor(227));
        valueColorMap.set(226, TicketFarben.getColor(226));
        valueColorMap.set(225, TicketFarben.getColor(225));
        valueColorMap.set(224, TicketFarben.getColor(224));

        columns.push(new StatusTableColumn('status', 'Status', valueColorMap));
        columns.push(new TableColumn('ersteller', 'Benutzer'));
        columns.push(new DateTableColumn('erstellt', 'Zeitstempel'));

        return columns;
    }
}
